// Cassaforte — selector de idioma para las pantallas públicas (inicio de sesión, registro, recuperación…)
import React from "react";
import { useTranslation } from "react-i18next";

const btn = (active: boolean): React.CSSProperties => ({
	border: 0, cursor: "pointer", font: "700 12px/1 \"Hanken Grotesk\", system-ui, sans-serif",
	padding: "7px 10px", borderRadius: 8,
	background: active ? "#D4A64A" : "transparent", color: active ? "#14282B" : "#C9D6D2",
});

const LanguageSwitch = () => {
	const { i18n } = useTranslation();
	const lang = (i18n.language || "es").startsWith("en") ? "en" : "es";
	return (
		<div role="group" aria-label="Idioma / Language"
			style={{ position: "fixed", top: 18, right: 22, display: "flex", gap: 2, padding: 3, borderRadius: 11, background: "rgba(255,255,255,.07)", zIndex: 10 }}>
			<button type="button" aria-pressed={lang === "es"} style={btn(lang === "es")} onClick={() => i18n.changeLanguage("es")}>ES</button>
			<button type="button" aria-pressed={lang === "en"} style={btn(lang === "en")} onClick={() => i18n.changeLanguage("en")}>EN</button>
		</div>
	);
};

export default LanguageSwitch;
